module.exports = "/img/19.2773ed.webp";